var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardiacOutput(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0187 13.2687C16.0187 13.2687 14.85 13.2688 14.0938 12.7188C12.65 11.7563 12.5812 10.2438 13.6812 9.00625C14.7812 7.76875 17.1875 7.21875 17.1875 7.21875V4.8125L16.3625 5.0875C12.375 6.25625 8.8 8.73125 6.1875 12.1",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.5625V6.05C5.5 5.3625 6.05 4.8125 6.7375 4.8125H8.9375V6.1875",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9375 6.1875V3.09375C8.9375 2.54375 9.41875 2.0625 9.96875 2.0625C10.5188 2.0625 11 2.54375 11 3.09375V6.875",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.875V4.46875C11 3.91875 11.4812 3.4375 12.0312 3.4375C12.5813 3.4375 13.0625 3.91875 13.0625 4.46875V6.1875",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5062 8.5937C15.3312 9.48745 15.95 10.6562 16.1562 12.1C16.5687 14.4375 19.4562 19.9375 13.2 19.9375C9.83125 19.9375 4.125 16.9125 4.125 12.1C4.125 9.07495 6.25625 6.6687 9.55625 6.6687C10.3812 6.6687 11.2062 6.8062 11.9625 7.01245",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardiacOutput);
export default __webpack_public_path__ + "static/media/CardiacOutput.85bc788f346c1b12ef50ec1b800a6bb3.svg";
export { ForwardRef as ReactComponent };